module.exports = __webpack_public_path__ + "img/empleados.9f67d97c.png";